const BaseHealing = 536421;
function slope(min, max, param, paramMin, paramMax) {
  return Math.min((param - paramMin) / (paramMax - paramMin) * (max - min) + min, max);
}

export const followerSkills = {
  Templar_Heal_110: {
    info(stats) {
      const amount = slope(BaseHealing * 0.36, BaseHealing * 0.80, stats.str, 10, 25000);
      return {
        "Cooldown": {cooldown: 30},
        "Healing": amount.toFixed(0),
      };
    },
  },
  Templar_Intervene: {
    info(stats) {
      return {
        //"Cooldown": {cooldown: 10},
        "Duration": {duration: slope(3, 6, stats.str, 10, 25000)},
      };
    },
  },
  Templar_Loyalty: {
    info(stats) {
      const amount = slope(BaseHealing * 0.012, BaseHealing * 0.037, stats.str, 10, 25000);
      return {
        "Regeneration": amount.toFixed(0),
      };
    },
    buffs(stats) {
      return {regen: slope(BaseHealing * 0.012, BaseHealing * 0.037, stats.str, 10, 25000)};
    },
    character(stats) {
      return {regen: slope(BaseHealing * 0.012, BaseHealing * 0.037, stats.str, 10, 25000)};
    },
  },
  Templar_Intimidate: {
    info(stats) {
      return {
        "Duration": {duration: slope(3, 6, stats.str, 10, 25000)},
      };
    },
  },
  Templar_ShieldCharge: {
    info(stats) {
      return {
        //"Cooldown": {cooldown: 10},
        "Damage": {coeff: 2.8, elem: "phy"},
        "Stun Duration": {duration: slope(3, 6, stats.str, 10, 25000)},
      };
    },
  },
  Templar_Onslaught_V2: {
    active: true,
    info(stats) {
      return {
        //"Cooldown": {cooldown: 20},
        "Damage": {coeff: 8, elem: "phy"},
        "Duration": {duration: slope(3, 6, stats.str, 10, 25000)},
      };
    },
    buffs: {dmgtaken: 10},
  },
  Templar_Inspire: {
    character(stats) {
      switch (stats.ownerClass) {
      case "wizard": return {apregen: 1.4};
      case "demonhunter": return {hatredregen: 1};
      case "witchdoctor": return {manaregen: 7};
      case "barbarian": return {resourcegen: 10};
      case "monk": return {resourcegen: 10};
      case "crusader": return {wrathregen: 1.1};
      case "necromancer": return {resourcegen: 10};
      // no default
      }
    },
  },
  Templar_CheatDeath_Passive: {
    info(stats) {
      const amount = slope(15, 25, stats.str, 10, 25000);
      return {
        //"Cooldown": {cooldown: 120},
        "Healing": amount.toFixed(2) + "%",
      };
    },
  },

  Scoundrel_CripplingShot: {
    info(stats) {
      return {
        //"Cooldown": {cooldown: 4},
        "Damage": {coeff: 1.4, elem: "phy"},
        "Slow Duration": {duration: slope(3, 6, stats.dex, 11, 25000)},
      };
    },
  },
  Scoundrel_PowerShot: {
    info(stats) {
      return {
        //"Cooldown": {cooldown: 8},
        "Damage": {coeff: 1.2, elem: "arc"},
        "Stun Duration": {duration: slope(3, 6, stats.dex, 11, 25000)},
      };
    },
  },
  Scoundrel_Hysteria: {
    active: true,
    info(stats) {
      return {
        "Duration": {duration: slope(3, 6, stats.dex, 11, 25000)},
      };
    },
    buffs: {damage: 3},
    character: {damage: 3},
  },
  Scoundrel_Anatomy: {
    info(stats) {
      const amount = slope(1.8, 4, stats.dex, 11, 25000);
      return {
        "Crit Chance": amount.toFixed(2) + "%",
      };
    },
    buffs(stats) {
      return {chc: slope(1.8, 4, stats.dex, 11, 25000)};
    },
    character(stats) {
      return {chc: slope(1.8, 4, stats.dex, 11, 25000)};
    },
  },
  Scoundrel_PiercingShot: {
    active: true,
    info(stats) {
      return {
        //"Cooldown": {cooldown: 20},
        "Damage": {coeff: 5, elem: "phy"},
        "Duration": {duration: slope(3, 6, stats.dex, 11, 25000)},
      };
    },
    buffs: {dmgtaken: 10},
  },
  X1_Scoundrel_Multishot: {
    info(stats) {
      const chance = slope(50, 70, stats.dex, 11, 25000);
      return {
        //"Cooldown": {cooldown: 8},
        "Damage": {coeff: 1.1, elem: "phy"},
        "Multishot Chance": chance.toFixed(2) + "%",
      };
    },
  },
  Scoundrel_CheatDeath_Passive: {
    info(stats) {
      return {
        //"Cooldown": {cooldown: 120},
        "Slow Duration": {duration: slope(3, 7, stats.dex, 11, 25000)},
      };
    },
  },
  Scoundrel_DebuffCloud: {
    active: false,
    info(stats) {
      return {
        //"Cooldown": {cooldown: 30},
        "Duration": {duration: slope(2, 4, stats.dex, 11, 25000)},
      };
    },
    buffs: {chctaken: 100},
  },

  Enchantress_Charm: {
    //info: {"Cooldown": {cooldown: 18}},
  },
  Enchantress_ArcaneOrb: {
    info(stats) {
      return {
        //"Cooldown": {cooldown: 4},
        "Damage": {coeff: 1.5, elem: "arc"},
        "Slow Duration": {duration: slope(3, 6, stats.int, 8, 25000)},
      };
    },
  },
  Enchantress_AmplifyElemental: {
    info(stats) {
      const amount = slope(5, 10, stats.int, 8, 25000);
      return {
        "Elemental Damage": amount.toFixed(2) + "%",
      };
    },
    character(stats) {
      const amount = slope(5, 10, stats.int, 8, 25000);
      return {
        dmgphy: amount,
        dmgfir: amount,
        dmgcol: amount,
        dmgpsn: amount,
        dmgarc: amount,
        dmglit: amount,
        dmghol: amount,
      };
    },
  },
  Enchantress_CooldownReduction: {
    info(stats) {
      const amount = slope(5, 10, stats.int, 8, 25000);
      return {
        "Cooldown Reduction": amount.toFixed(2) + "%",
      };
    },
    character(stats) {
      return {cdr: slope(5, 10, stats.int, 8, 25000)};
    },
  },
  Enchantress_CombinedShield: {
    info(stats) {
      return {
        "Slow Duration": {duration: slope(3, 6, stats.int, 8, 25000)},
      };
    },
    buffs: {rangedef: 6, armor_percent: 3},
    character: {rangedef: 6, armor_percent: 3},
  },
  Enchantress_ScorchedEarth: {
    active: true,
    info(stats) {
      return {
        //"Cooldown": {cooldown: 20},
        "Damage": {coeff: 3.3, elem: "arc", total: true},
        "Duration": {duration: slope(5, 7, stats.int, 8, 25000)},
      };
    },
    buffs: {dmgtaken: 10},
  },
  Enchantress_FocusedMind: {
    info(stats) {
      const amount = slope(3, 6, stats.int, 8, 25000);
      return {
        "Attack Speed": amount.toFixed(2) + "%",
      };
    },
    buffs(stats) {
      return {ias: slope(3, 6, stats.int, 8, 25000)};
    },
    character(stats) {
      return {ias: slope(3, 6, stats.int, 8, 25000)};
    },
  },
  Enchantress_CheatDeath_Passive: {
    info(stats) {
      return {
        //"Cooldown": {cooldown: 120},
        "Slow Duration": {duration: slope(3, 7, stats.int, 8, 25000)},
      };
    },
  },
};
